import { motion } from "framer-motion";
import { APPS } from "../data/apps";

export const FolderTile = ({ onOpen }) => {
  return (
    <div className="flex flex-col items-center gap-3">
      <motion.button
        type="button"
        data-testid="folder-tile"
        layoutId="eyb-folder"
        onClick={onOpen}
        whileTap={{ scale: 0.93 }}
        whileHover={{ y: -6 }}
        transition={{ type: "spring", stiffness: 200, damping: 26 }}
        className="relative grid h-[104px] w-[104px] grid-cols-2 grid-rows-2 gap-2 rounded-[28px] border border-white/15 bg-white/10 p-3 backdrop-blur-2xl focus:outline-none focus-visible:ring-2 focus-visible:ring-white/60"
        style={{
          boxShadow:
            "0 22px 44px rgba(3,20,45,0.55), inset 0 1px 1px rgba(255,255,255,0.35)",
        }}
      >
        {APPS.map((app) => {
          const Icon = app.icon;
          return (
            <div
              key={app.id}
              className={`grid place-items-center rounded-[12px] bg-gradient-to-b ${app.gradient}`}
              style={{ boxShadow: "inset 0 1px 1px rgba(255,255,255,0.4)" }}
            >
              <Icon size={17} strokeWidth={2} className="text-white" />
            </div>
          );
        })}
      </motion.button>
      <span
        data-testid="folder-label"
        className="text-sm font-medium tracking-wide text-white/90"
      >
        EYB Apps
      </span>
    </div>
  );
};
